<template>
  <div class="px-sm-4">
    <b-card body-class="p-md-1 p-0">
      <b-card-header class="align-items-start flex-sm-row flex-column-reverse">
        <b-card-title class="mt-sm-0 mt-2">
          <b-media class="align-items-center">
            <template #aside>
              <div
                v-if="logoPreview || logo"
                class="bg-dark d-flex justify-content-center align-items-center bg-secondary rounded-avatar"
                style="height: 100px"
              >
                <b-img
                  ref="previewEl"
                  :src="logoPreview || logo || errorImage"
                  :alt="name"
                  width="100px"
                  style="max-height: 100px"
                  rounded
                  class="p-25"
                  @error="setAltImg"
                />
              </div>
              <b-avatar
                ref="previewEl"
                :alt="name"
                size="100px"
                class="bg-secondary text-muted rounded-avatar"
                v-else
              >
              </b-avatar>
            </template>
            <h5 class="mb-1 text-white">
              {{ $route.params.id ? "Edit sponsor" : "Create sponsor" }}
            </h5>
            <div class="d-flex flex-wrap">
              <b-button
                class="gradient-btn ml-50 px-75"
                @click="$refs.previewLogo.click()"
              >
                <input
                  @input="changeLogo"
                  ref="previewLogo"
                  type="file"
                  class="d-none"
                  accept="image/*"
                />
                <span class="d-none d-sm-inline">Upload</span>
                <feather-icon icon="EditIcon" class="d-inline d-sm-none" />
              </b-button>
              <b-button
                class="ml-50 px-75"
                @click="removeLogo"
                :disabled="!$route.params.id || !logo"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
            </div>
          </b-media>
        </b-card-title>

        <b-link :to="{ name: 'sponsors' }">
          <span>back to the sponsor list </span>
          <feather-icon icon="ChevronRightIcon"
        /></b-link>
      </b-card-header>
      <b-card-body>
        <validation-observer ref="createForm">
          <b-form class="form mt-2" @submit.prevent="createForm">
            <b-row>
              <b-col class="d-flex" lg="4">
                <b-form-group label-for="name" class="w-100" label="Name">
                  <validation-provider
                    #default="{ errors }"
                    name="Name"
                    rules="required"
                  >
                    <b-form-input
                      id="name"
                      v-model="name"
                      name="name"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- <b-col class="d-flex" lg="4">
                <b-form-group
                  label-for="support_amount"
                  class="w-100"
                  label="Support amount ($)"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Support amount"
                    rules="required"
                  >
                    <b-form-input
                      id="support_amount"
                      v-model="support_amount"
                      min="0"
                      type="number"
                      step="0.01"
                      name="support_amount"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col> -->

              <b-col class="d-flex" lg="4">
                <b-form-group
                  label-for="business_scale"
                  class="w-100"
                  label="Business scale"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="business scale"
                    rules="required"
                  >
                    <v-select
                      :options="businessScales"
                      v-model="business_scale"
                      :searchable="false"
                      label="scale"
                      :reduce="(option) => option.value"
                    ></v-select>
                    <!-- <b-form-input
                      id="business_scale"
                      v-model="business_scale"
                      min="1"
                      type="number"
                      name="business_scale"
                      :state="errors.length > 0 ? false : null"
                    /> -->
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col class="d-flex" lg="4">
                <b-form-group
                  label-for="audience"
                  class="w-100"
                  label="Audience"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="audience"
                    rules="required"
                  >
                    <b-form-input
                      id="audience"
                      v-model="audience"
                      min="1"
                      type="number"
                      name="audience"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col class="d-flex flex-wrap px-0" lg="8">
                <b-col class="d-flex align-items-center my-2" lg="6">
                  <b-form-group
                    class="w-100 d-flex align-items-center mb-0 warning-button"
                  >
                    <b-form-checkbox
                      v-model="active"
                      name="active"
                      switch
                      inline
                      :uncheckedValue="0"
                      :value="1"
                    >
                      active
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
                <b-col class="d-flex align-items-center my-2" lg="6">
                  <b-form-group
                    class="w-100 d-flex align-items-center mb-0 warning-button"
                  >
                    <b-form-checkbox
                      v-model="special"
                      name="special"
                      switch
                      inline
                      :uncheckedValue="0"
                      :value="1"
                    >
                      special
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
                <b-col class="d-flex" lg="12">
                  <b-form-group
                    label-for="description"
                    class="w-100"
                    label="Description"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Description"
                    >
                      <b-form-textarea
                        id="description"
                        v-model="description"
                        name="description"
                        :state="errors.length > 0 ? false : null"
                        rows="4"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-col>
              <b-col class="d-flex flex-column pt-2 mt-50" lg="4">
                <b-form-group
                  class="w-100 position-relative"
                  label="Upload cover"
                >
                  <div
                    v-if="coverPreview || cover"
                    class="d-flex align-items-center justify-content-center py-3"
                  >
                    <b-img
                      ref="previewEl"
                      :src="coverPreview || cover || errorImage"
                      :alt="name"
                      fluid
                      rounded
                      class="p-25"
                      @error="setAltImg"
                    />
                  </div>
                  <b-avatar
                    ref="previewEl"
                    :alt="name"
                    style="height: 150px; width: 100%"
                    rounded
                    class="bg-secondary text-muted"
                    v-else
                  >
                    <feather-icon icon="ImageIcon" size="60" class="mb-3" />
                  </b-avatar>
                  <div
                    class="d-flex w-100 justify-content-center banner-btns flex-wrap mb-4"
                  >
                    <b-button
                      :class="[
                        coverPreview || cover ? 'gradient-btn' : 'border',
                        'ml-50 px-75',
                      ]"
                      @click="$refs.refInputEl.click()"
                    >
                      <input
                        @input="changeCover"
                        ref="refInputEl"
                        type="file"
                        class="d-none"
                        accept="image/*"
                      />
                      <span class="d-none d-sm-inline">Upload</span>
                      <feather-icon
                        icon="EditIcon"
                        class="d-inline d-sm-none"
                      />
                    </b-button>
                    <b-button
                      class="ml-50 px-75 border"
                      @click="removeCover"
                      :disabled="!$route.params.id || !cover"
                    >
                      <feather-icon icon="TrashIcon" />
                    </b-button>
                  </div>
                </b-form-group>
              </b-col>
              <b-col class="d-flex flex-column mb-2 mt-sm-0 mt-2" lg="4">
                <b-form-group
                  class="w-100 position-relative"
                  label="Upload banner"
                >
                  <div
                    v-if="bannerPreview || banner"
                    class="d-flex align-items-center justify-content-center py-3"
                  >
                    <b-img
                      ref="previewEl"
                      :src="bannerPreview || banner || errorImage"
                      :alt="name"
                      fluid
                      rounded
                      class="p-25"
                      @error="setAltImg"
                    />
                  </div>
                  <b-avatar
                    ref="previewEl"
                    :alt="name"
                    style="height: 150px; width: 100%"
                    rounded
                    class="bg-secondary text-muted"
                    v-else
                  >
                    <feather-icon icon="ImageIcon" size="60" class="mb-3" />
                  </b-avatar>
                  <div
                    class="d-flex w-100 justify-content-center banner-btns flex-wrap mb-4"
                  >
                    <b-button
                      :class="[
                        bannerPreview || banner ? 'gradient-btn' : 'border',
                        'ml-50 px-75',
                      ]"
                      @click="$refs.refInputBanner.click()"
                    >
                      <input
                        @input="changeBanner"
                        ref="refInputBanner"
                        type="file"
                        class="d-none"
                        accept="image/*"
                      />
                      <span class="d-none d-sm-inline">Upload</span>
                      <feather-icon
                        icon="EditIcon"
                        class="d-inline d-sm-none"
                      />
                    </b-button>
                    <b-button
                      class="ml-50 px-75 border"
                      @click="removeBanner"
                      :disabled="!$route.params.id || !banner"
                    >
                      <feather-icon icon="TrashIcon" />
                    </b-button>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <div class="d-flex align-items-center justify-content-end">
              <b-button class="gradient-btn" type="submit"> submit </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
    <loader :loading="loading" />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BLink,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
  BFormTextarea,
  BMedia,
  BAvatar,
  BImg,
} from "bootstrap-vue";
import { required } from "@validations";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import Loader from "@/@core/components/loader/Loader.vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BLink,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    Loader,
    SelectBox,
    BFormTextarea,
    BMedia,
    BAvatar,
    BImg,
    vSelect,
  },
  data() {
    return {
      name: "",
      special: 0,
      starting_balance: "",
      support_amount: "",
      business_scale: "",
      audience: "",
      description: "",
      active: 1,
      logo: "",
      logoPreview: "",
      cover: "",
      coverPreview: "",
      banner: "",
      bannerPreview: "",
      loading: false,
      businessScales: [
        {
          value: 10,
          scale: "0-10 employee",
        },
        {
          value: 50,
          scale: "10-50 employee",
        },
        {
          value: 500,
          scale: "50-500 employee",
        },
        {
          value: 1000,
          scale: "500-1000 employee",
        },
      ],
      // validation rules
      required,
    };
  },
  created() {
    if (this.$route.params.id) {
      this.getSponsor();
    }
  },

  methods: {
    async removeCover() {
      this.loading = true;
      if (this.$route.params.id) {
        try {
          await this.$http.delete(
            `panel/sponsors/${this.$route.params.id}/cover`
          );
          await this.getSponsor();
        } catch (err) {}
      } else {
        this.cover = "";
        this.coverPreview = "";
        this.$refs.refInputEl.value = "";
      }
      this.loading = false;
    },
    async removeLogo() {
      this.loading = true;
      if (this.$route.params.id) {
        try {
          await this.$http.delete(
            `panel/sponsors/${this.$route.params.id}/logo`
          );
          await this.getSponsor();
        } catch (err) {}
      } else {
        this.logo = "";
        this.logoPreview = "";
        this.$refs.previewLogo.value = "";
      }
      this.loading = false;
    },
    async removeBanner() {
      this.loading = true;
      if (this.$route.params.id) {
        try {
          await this.$http.delete(
            `panel/sponsors/${this.$route.params.id}/banner`
          );
          await this.getSponsor();
        } catch (err) {}
      } else {
        this.banner = "";
        this.bannerPreview = "";
        this.$refs.refInputBanner.value = "";
      }
      this.loading = false;
    },
    async changeCover(e) {
      this.loading = true;
      if (this.$route.params.id) {
        try {
          let formData = new FormData();
          formData.append("cover", e.target.files[0]);
          const { data } = await this.$http.post(
            `panel/sponsors/${this.$route.params.id}/cover?_method=patch`,
            formData
          );
          this.$refs.refInputEl.value = "";
          await this.getSponsor();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Sponsor cover Updated",
              icon: "EditIcon",
              variant: "success",
            },
          });
        } catch (err) {}
      } else {
        this.cover = e.target.files[0];
        this.coverPreview = URL.createObjectURL(this.cover);
      }
      this.loading = false;
    },
    async changeLogo(e) {
      this.loading = true;
      if (this.$route.params.id) {
        try {
          let formData = new FormData();
          formData.append("logo", e.target.files[0]);
          const { data } = await this.$http.post(
            `panel/sponsors/${this.$route.params.id}/logo?_method=patch`,
            formData
          );
          this.$refs.previewLogo.value = "";
          await this.getSponsor();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Sponsor logo Updated",
              icon: "EditIcon",
              variant: "success",
            },
          });
        } catch (err) {}
      } else {
        this.logo = e.target.files[0];
        this.logoPreview = URL.createObjectURL(this.logo);
      }
      this.loading = false;
    },
    async changeBanner(e) {
      this.loading = true;
      if (this.$route.params.id) {
        try {
          let formData = new FormData();
          formData.append("banner", e.target.files[0]);
          const { data } = await this.$http.post(
            `panel/sponsors/${this.$route.params.id}/banner?_method=patch`,
            formData
          );
          this.$refs.refInputBanner.value = "";
          await this.getSponsor();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Sponsor banner Updated",
              icon: "EditIcon",
              variant: "success",
            },
          });
        } catch (err) {}
      } else {
        this.banner = e.target.files[0];
        this.bannerPreview = URL.createObjectURL(this.banner);
      }
      this.loading = false;
    },
    async getSponsor() {
      this.loading = true;
      try {
        const { data } = await this.$http.get(
          `/panel/sponsors/${this.$route.params.id}`
        );
        await Object.keys(data.data).map((item) => {
          if (item == "active" || item == "special") {
            this[item] = data.data[item] ? 1 : 0;
          } else {
            this[item] = data.data[item];
          }
        });
      } catch (err) {}
      this.loading = false;
    },
    createForm() {
      this.$refs.createForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            this.formData = await new FormData();
            let newObject = await {
              name: this.name,
              special: this.special,
              starting_balance: this.starting_balance,
              support_amount: 0,
              business_scale: this.business_scale,
              audience: this.audience,
              description: this.description,
              active: this.active,
            };

            (await !this.$route.params.id) && this.logo
              ? (newObject.logo = this.logo)
              : "";
            (await !this.$route.params.id) && this.cover
              ? (newObject.cover = this.cover)
              : "";
            (await !this.$route.params.id) && this.banner
              ? (newObject.banner = this.banner)
              : "";
            await Object.keys(newObject).map((item, index) => {
              this.setFormData(newObject[item], index, item);
            });

            if (this.$route.params.id) {
              const { data } = await this.$http.post(
                `panel/sponsors/${this.$route.params.id}?_method=put`,
                this.formData
              );
              await this.getSponsor();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Sponsor Updated",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } else {
              const { data } = await this.$http.post(
                "panel/sponsors",
                this.formData
              );
              this.$router.push({ name: "sponsors" });
            }
          } catch (err) {}
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style></style>
